import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AdyenPayoutMethodStatus, PayoutMethod, PayoutMethodProvider } from '../../services/payout-methods.service';

@Component({
  standalone: false,
  selector: 'sbnb-direct-payout-method-status',
  templateUrl: './direct-payout-method-status.component.html',
  styleUrls: ['./direct-payout-method-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DirectPayoutMethodStatusComponent implements OnInit {
  @Input() payout: PayoutMethod;

  @Output() verificationClicked: EventEmitter<null> = new EventEmitter();

  PayoutMethodProvider = PayoutMethodProvider;
  AdyenPayoutMethodStatus = AdyenPayoutMethodStatus;

  constructor() { }

  ngOnInit(): void { }
}
